import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { prefix: String }

  redirectToTimespan(event) {
    const el = event.currentTarget

    Turbo.visit('/' + this.prefixValue + '/' + el.options[el.selectedIndex].value)
  }
}
